import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TransportistaGatewayHttpService,
  TransportistaGatewayPostOptions,
} from '../interceptor/http';

export type ViajesFirmaTipo = 'RECEPCION' | 'ADICION_AGUA' | 'DEVOLUCION_HORMIGON';

/** POST /api/transportista/viajes/firma — firma digital (canvas). */
export interface ViajesFirmaRequest {
  mx_tkt_h: string;
  mx_numero_pedido_h: string;
  tipo_firma?: ViajesFirmaTipo;
  mx_cli_firma_rut: string;
  mx_cli_firma_nombre: string;
  mx_cli_firma: string;
  mx_cli_firma_correo: string;
  /** Solo áridos. Se omite en hormigón. */
  mx_cli_firma_correo_dos?: string;
  comentario?: string;
}

/** Respuesta exitosa típica de POST /viajes/firma. */
export interface ViajesFirmaResponse {
  success: boolean;
  code: string;
  message: string;
  errors: unknown | null;
  businessType?: string;
  ticket?: string;
  orderNumber?: string;
  signatureFormat?: string;
  signatureSizeBytes?: number;
  savedAt?: string;
}

@Injectable({ providedIn: 'root' })
export class TransportistaViajesFirmaGatewayApi {
  constructor(private readonly gw: TransportistaGatewayHttpService) {}

  post(
    body: ViajesFirmaRequest,
    options?: TransportistaGatewayPostOptions
  ): Observable<ViajesFirmaResponse> {
    return this.gw.post<ViajesFirmaResponse>('/viajes/firma', body, options);
  }
}
